export default __webpack_public_path__ + "static/media/inex_4_11zon.358acb79.png";